import { Confirm } from "./Confirm";

interface Props {
  show: ({ message }: { message: string }) => Promise<boolean>;
}

export const confirmService: Props = Confirm.create({}) as any;
